export default __webpack_public_path__ + "static/approval-workflow-12b8c5c5d57bcc2044f2620861c9afb4.gif";